"use strict";

define('model/notification',['./base', 'datakit/model.registry', 'backbone'], function (BaseModel, ModelRegistry, Backbone) {
  var Notification = BaseModel.extend({
    urlRoot: '/rs/api/notification',
    childModels: {
      'notificationCode': 'MessageCode'
    },
    virtual: {
      'kind': BaseModel.createKeyPathVirtual('notificationCode.notificationKind.description'),
      'studyLabel': function studyLabel() {
        switch (this.get('kind')) {
          case 'Workflow':
            return this.get('ownerId.studyLabel');
          case 'Study':
            return this.get('ownerId.label');
        }
      },
      'studyId': function studyId() {
        switch (this.get('kind')) {
          case 'Workflow':
            return this.get('ownerId.studyId');
          case 'Study':
            return this.get('ownerId.id');
        }
      },
      'documentId': BaseModel.createKeyPathVirtual('ownerId.id'),
      'principalInvestigator': function principalInvestigator() {
        var person = this.get('ownerId.responsiblePersons.0');
        if (person) {
          return [person.firstName, person.lastName].join(' ');
        }
      }
    },
    markViewed: function markViewed() {
      var model = this;
      return Notification.markAsViewed(new Backbone.Collection([model]));
    },
    parse: function parse() {
      var data = BaseModel.prototype.parse.apply(this, arguments);
      return Notification.parseOwnerId(data || {});
    },
    collectionParse: function collectionParse() {
      var data = BaseModel.prototype.collectionParse.apply(this, arguments);
      return _.map(data, Notification.parseOwnerId, Notification);
    }
  }, {
    all: function all(app) {
      return this.createCollection('/rs/api/notification/:app').params({
        app: app
      });
    },
    markAsViewed: function markAsViewed(collection) {
      var ids = collection.pluck('id');
      var options = {
        type: 'POST',
        contentType: 'application/json',
        url: '/rs/api/notification/viewed',
        data: JSON.stringify(ids),
        success: function success(resp) {
          collection.each(function (model) {
            model.set('viewDate', new Date().getTime());
          });
          collection.trigger('sync', collection, resp, options);
        },
        error: function error(resp) {
          collection.trigger('error', collection, resp, options);
        }
      };
      return Backbone.sync(null, collection, options);
    },
    markAllAsViewed: function markAllAsViewed(collection) {
      var options = {
        type: 'POST',
        contentType: 'application/json',
        url: '/rs/api/notification/viewed/all',
        success: function success(resp) {},
        error: function error(resp) {}
      };
      return Backbone.sync(null, collection, options);
    },
    deleteAll: function deleteAll(collection) {
      var options = {
        type: 'DELETE',
        contentType: 'application/json',
        url: '/rs/api/notification/all',
        success: function success(resp) {
          collection.set([]);
          collection.trigger('sync', collection, resp, options);
        },
        error: function error(resp) {
          collection.trigger('error', collection, resp, options);
        }
      };
      return Backbone.sync(null, collection, options);
    },
    buildOwnerId: function buildOwnerId(kind, ownerId) {
      var Study = ModelRegistry.get('Study'),
        Document = ModelRegistry.get('Document');
      switch (kind) {
        case 'Workflow':
          return new Document(ownerId);
        case 'Study':
          return new Study(ownerId);
      }
      return new BaseModel(ownerId);
    },
    parseOwnerId: function parseOwnerId(data) {
      var kind = '';
      data = data || {};
      try {
        kind = data.notificationCode.notificationKind.description;
      } catch (e) {}
      return _.extend({}, data, {
        ownerId: Notification.buildOwnerId(kind, data.ownerId)
      });
    }
  });
  return Notification;
});

